import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/coverage/license.coverage.query.gql"
import type {
  LicenseCoverageQuery,
  LicenseCoverageQueryVariables,
} from "@/v2-backoffice-client/license/coverage/__types__/license.coverage.query"

type Options = QueryHookOptions<
  LicenseCoverageQuery,
  LicenseCoverageQueryVariables
>

export function useLicenseCoverageQuery(options?: Options) {
  return useQuery<LicenseCoverageQuery, LicenseCoverageQueryVariables>(
    query,
    options,
  )
}
